<template>
  <b-card
    :body-class="isTotalizer ? 'py-1' : ''"
    :class="device.device_name.toLowerCase() !== 'debit' ? 'my-custom-class' : ''"
    :style="device.sensor_status === 'false' ? { backgroundColor: '#0E74FF' } : (hasLimit ? { backgroundColor: device.device_value < limit.min || device.device_value > limit.max ? '#FC4C02' : 'green' } : '')"
  >
    <b-card-title>
      <h5
        v-if="isTotalizer"
        :class="device.device_name.toLowerCase() === 'debit' && device.sensor_status === 'false' ? 'text-white' : (device.device_name.toLowerCase() !== 'debit' ? 'text-white' : '')"
      >{{ device.device_name }}</h5>
      <h4
        v-if="!isTotalizer"
        :class="device.device_name.toLowerCase() === 'debit' && device.sensor_status === 'false' ? 'text-white' : (device.device_name.toLowerCase() !== 'debit' ? 'text-white' : '')"
      >{{ device.device_name }}</h4>
    </b-card-title>
    <div class="ml-2">
      <h3
        v-if="isTotalizer"
        :class="device.device_name.toLowerCase() !== 'debit' ? 'text-white' : (device.device_name.toLowerCase() === 'debit' && device.sensor_status === 'false' ? 'text-white' : '')"
      >
        <font>
          {{ device.device_value }}
        </font>
        <small>
          <font>{{ device.device_default_unit }}</font>
        </small>
      </h3>
      <h2
        v-if="!isTotalizer"
        :class="device.device_name.toLowerCase() !== 'debit' ? 'text-white' : (device.device_name.toLowerCase() === 'debit' && device.sensor_status === 'false' ? 'text-white' : '')"
      >
        <font>
          {{ device.device_value }}
        </font>
        <small>
          <font>{{ device.device_default_unit }}</font>
        </small>
      </h2>
    </div>
  </b-card>
</template>
<script>
import { BCard, BCardTitle } from 'bootstrap-vue'

export default {
  name: 'DeviceCard',
  components: { BCard, BCardTitle },
  props: {
    device: {
      type: Object,
      default: () => {},
    },
    limit: {
      type: Object,
      default: () => {},
    },
    hasLimit: {
      type: Boolean,
      default: true,
    },
    isTotalizer: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
